import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Input from "components/common/Input";
import Typography from "components/common/Typography";
import { useContext, useState } from "react";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { deleteMyPlansAsync } from "./myplans.slice";

interface Props {
  openDeleteCapthaDialog: any;
  setOpenDeleteCapthaDialog: any;
  plan: any;
}

function Delete(props: Props) {
  const captchaWord = "DELETE";
  const dispatch: any = useAppDispatch();
  const { openDeleteCapthaDialog, setOpenDeleteCapthaDialog, plan } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [captchaInput, setCaptchaInput] = useState(String);

  const handleCloseDeleteDialog = () => {
    setOpenDeleteCapthaDialog(false);
  };

  const planDeleteAction = async () => {
    setOpenDeleteCapthaDialog(false);
    await dispatch(deleteMyPlansAsync({ id: plan?.id }));
  };

  return (
    openDeleteCapthaDialog && (
      <DialogFormation
        title="Please confirm that you wish to delete this plan"
        openDialog={openDeleteCapthaDialog}
        handleClose={handleCloseDeleteDialog}
        actionConfig={
          <div className="modal-config-wrapper">
            <Button
              variant="secondary"
              label="Cancel"
              onClick={handleCloseDeleteDialog}
              width={isMobileScreen ? "50%" : "25%"}
            />
            <Button
              variant="primary"
              label="Confirm"
              disabled={captchaInput !== captchaWord}
              onClick={planDeleteAction}
              width={isMobileScreen ? "50%" : "25%"}
            />
          </div>
        }
      >
        <Box
          width="100%"
          alignItems={"center"}
          justifyContent="center"
          textAlign={"center"}
          display={"flex"}
          flexDirection="column"
          gap={"20px"}
        >
          <Typography variant={"body2"} color={tokens.Text.General.PrimaryHeadline}>
            "{plan.title ?? plan.name}"
          </Typography>
          <Typography variant={"body2"} showBold color={tokens.Text.General.PrimaryHeadline}>
            Enter the word "DELETE" in input below.
          </Typography>
          <Input
            handleChangeUpdate={(val) => {
              setCaptchaInput(val);
            }}
            name="Title"
            placeholder="Enter the word DELETE in all caps."
            textVariant="body2"
            label={""}
          />
        </Box>
      </DialogFormation>
    )
  );
}

export default Delete;
